// extracted by mini-css-extract-plugin
export default {"aboutText":"aboutUs_aboutText__B7IrV","aboutCont":"aboutUs_aboutCont__-SPjo","linkCont":"aboutUs_linkCont__QFUDc","linkText":"aboutUs_linkText__ZAwbc"};